import React,{useEffect} from 'react';
import * as FaIcons from 'react-icons/fa';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FaApple}=FaIcons;
const {FiStar}=FiIcons;
const APP_STORE_URL='https://apps.apple.com/us/app/paddle-up-pickleball-ai-coach/id6809176237';
const GOOGLE_PLAY_URL='https://play.google.com/store/apps/details?id=com.rork.paddleup';

function isIosDevice() {
  const userAgent=navigator.userAgent||navigator.vendor||window.opera;
  const isClassicIos=/iPad|iPhone|iPod/.test(userAgent);
  const isIpadDesktopMode=navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1;
  return isClassicIos||isIpadDesktopMode;
}

function StoreButton({icon,eyebrow,label}) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noreferrer"
      className="store-button store-button-light"
    >
      <SafeIcon icon={icon} className="text-[2.8rem]" />
      <span className="text-left">
        <span className="block text-[11px] font-semibold leading-none opacity-65">
          {eyebrow}
        </span>
        <span className="mt-1 block text-2xl font-bold leading-none">
          {label}
        </span>
      </span>
    </a>
  );
}

export default function Home() {
  useEffect(()=> {
    if (isIosDevice()) {
      window.location.replace(APP_STORE_URL);
    }
  },[]);

  return (
    <div className="relative flex min-h-[calc(100vh-145px)] flex-grow items-center justify-center overflow-hidden px-5 py-16">
      <div className="hero-grid" aria-hidden="true" />
      <div className="hero-orb hero-orb-lime" aria-hidden="true" />
      <div className="hero-orb hero-orb-green" aria-hidden="true" />
      <section className="relative z-10 mx-auto flex w-full max-w-7xl flex-col items-center text-center">
        <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-[#c8ff1a]/20 bg-[#c8ff1a]/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.14em] text-[#c8ff1a] backdrop-blur-md">
          <SafeIcon icon={FiStar} className="text-sm" />
          #1 AI Pickleball Coach
        </div>
        <div className="brand-mark">
          <img
            src="https://global.divhunt.com/95b2c98f12e1bee2084076099cb284e9_863699.png"
            alt="Paddle Up logo"
          />
        </div>
        <h1 className="hero-title" aria-label="Paddle Up">
          <span>PADDLE UP</span>
        </h1>
        <div className="mt-11 flex w-full flex-col items-center justify-center gap-4 sm:w-auto">
          <StoreButton
            icon={FaApple}
            eyebrow="Download on the"
            label="App Store"
          />
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noreferrer"
            className="store-image-button"
          >
            <img
              src="https://global.divhunt.com/2af1aa34d0e9e3ecc86ecb561fe66838_9163.avif"
              alt="Get it on Google Play"
            />
          </a>
        </div>
      </section>
    </div>
  );
}